// frontend/src/components/NotificationBadge.tsx
// Badge component for displaying unread notification count

import React from 'react';

interface NotificationBadgeProps {
  count: number;
  max?: number;
  className?: string;
  style?: React.CSSProperties;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  count,
  max = 99,
  className = '',
  style = {}
}) => {
  // Don't render if no unread notifications
  if (!count || count === 0) {
    return null;
  }

  // Format display count (e.g., "99+" for counts over max)
  const displayCount = count > max ? `${max}+` : count.toString();

  return (
    <span
      className={`absolute top-0 right-0 translate-x-1/2 -translate-y-1/2 z-10 ${className}`}
      style={{
        padding: '0.1rem 0.35rem',
        minWidth: '1.3rem',
        height: '1.3rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '9999px',
        backgroundColor: '#ef4444',
        ...style
      }}
    >
      <span
        style={{
          fontSize: '0.65rem',
          fontWeight: 700,
          color: '#ffffff',
          lineHeight: 1,
          textAlign: 'center',
          display: 'block'
        }}
      >
        {displayCount}
      </span>
    </span>
  );
};

export default NotificationBadge;
